import Vue from 'vue'
import VueRouter from 'vue-router'
import { applyRouteMeta } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: () => import(/* webpackChunkName: "welcome" */ '@/views/Welcome.vue')
    },
    {
        path: '/rekrutacja',
        name: 'recruitment',
        component: () => import(/* webpackChunkName: "recruitment" */ '@/views/Recruitment.vue')
    },
    {
        path: '/zespol',
        name: 'team',
        component: () => import(/* webpackChunkName: "team" */ '@/views/Team.vue')
    },
    {
        path: '/kontakt',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact.vue')
    },
    {
        path: '/osiagniecia',
        name: 'achievements',
        component: () => import(/* webpackChunkName: "achievements" */ '@/views/Achievements.vue')
    },
    {
        path: '/o-nas',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    },
    {
        path: '/zawody',
        name: 'competitions',
        component: () => import(/* webpackChunkName: "competitions" */ '@/views/Competitions.vue')
    },
    {
        path: '/granty',
        name: 'grants',
        component: () => import(/* webpackChunkName: "grants" */ '@/views/Grants.vue')
    },
]

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes: routes
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    next()
})

router.afterEach((to) => {
    if (router.app) {
        applyRouteMeta(to, router.app)
    }
})

export default router
